/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type TaskPriority = typeof TaskPriority[keyof typeof TaskPriority];


export const TaskPriority = {
  none: 'none',
  urgent: 'urgent',
  high: 'high',
  medium: 'medium',
  low: 'low',
} as const;
